import { Autocomplete, Box, Button, CircularProgress, Grid, TextField } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../functions/axios';
import { parseDate } from '../../functions/functions';
import { useAuthContext } from '../../hooks/useAuthContext';
import { DateSelectorSingle } from './DateSelectorSingle';

const NoteCreate = () => {
  const { user } = useAuthContext();
  const [drivers, setDrivers] = useState(null);
  const [driverIdForm, setDriverIdForm] = useState(null);
  const [note, setNote] = useState('');
  const [dateForm, setDateForm] = useState(parseDate().day);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;

    (async () => {
      try {
        const response = await axios.get('/driver');
        const transformed = response.data
          .sort((...args) => {
            const [a, b] = args.map(({ name }) => name);
            return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
          })
          .map((record) => ({
            label: record.name,
            id: record._id,
          }));
        setDrivers(transformed);
      } catch (err) {
        console.log(err);
      }
    })();
  }, [user]);

  const postNoteData = useCallback(async () => {
    try {
      await axios.post('/notes', {
        date: dateForm,
        driver: driverIdForm,
        value: note,
        context: 'notes',
      });
      navigate('/notes');
    } catch (err) {
      console.log(err);
    }
  }, [dateForm, driverIdForm, navigate, note]);

  if (!user) return null;

  return (
    <>
      <Box style={{ margin: '0 25px', display: 'flex', gap: '25px', alignItems: 'center' }}>
        <DateSelectorSingle date={dateForm} setDate={setDateForm} />
        <Autocomplete
          disablePortal
          options={drivers}
          getOptionLabel={(option) => option?.label || ''}
          value={drivers?.find((d) => d.id === driverIdForm) || null}
          sx={{
            width: 432,
            '& .MuiInputBase-root': {
              color: 'white',
            },
            '& .MuiOutlinedInput-root': {
              color: 'white',
            },
            '& .MuiAutocomplete-input': {
              color: 'white',
            },
            '& .MuiAutocomplete-option': {
              color: 'white',
              backgroundColor: '#222',
              '&[aria-selected="true"]': {
                color: 'white',
              },
              '&.Mui-focused': {
                color: 'white',
              },
            },
            '& .MuiSvgIcon-root': {
              color: 'white',
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label='Kierowca'
              InputLabelProps={{ style: { color: 'white' } }}
              InputProps={{
                ...params.InputProps,
                style: { color: 'white' },
              }}
            />
          )}
          onChange={(e, value) => setDriverIdForm(value ? value.id : null)}
        />
      </Box>
      <Box style={{ padding: '25px', width: '100%' }}>
        <TextField
          style={{ color: 'white' }}
          value={note}
          fullWidth
          label='Notatka'
          multiline
          rows={15}
          variant='outlined'
          onChange={(e) => setNote(e.target.value)}
        />
      </Box>
      <Box style={{ display: 'flex', padding: '25px', width: '100%', justifyContent: 'space-between' }}>
        <Button variant='outlined' style={{ width: '250px' }} onClick={navigate.bind(null, `/notes`)}>
          Wróć do listy
        </Button>
        <Button disabled={!note || !driverIdForm} variant='contained' style={{ width: '250px' }} onClick={postNoteData}>
          Zapisz
        </Button>
      </Box>
    </>
  );
};

export default NoteCreate;
